import apiClient from "./apiClient";

const withoutEmpty = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== "" && value != null),
  );

// ClientVisit { id, date, purpose, status: "PENDING"|"APPROVED"|"REJECTED"|"CANCELLED",
//   clients: [{ id, name, address, hasLocation }], expired (pending and the date
//   has arrived), approvals, reviewRemarks, canCancel, waitingFor, managersAbove }
// The employee is taken from the access token.
export const clientVisitService = {
  // { canFile, clients: [{ id, name, address, hasLocation }] }
  getOptions: () => apiClient.get("/client-visits/options"),

  // ClientVisit[] newest first
  getMine: (filters = {}) =>
    apiClient.get("/client-visits/my", { params: withoutEmpty(filters) }),

  // { date (after today), clientIds[], purpose }. 409: one request per day.
  file: (data) => apiClient.post("/client-visits", data),

  cancel: (id) => apiClient.patch(`/client-visits/${id}/cancel`, {}),
};
